import * as React from "react";
import styled from "styled-components";
import { IconButton } from "components/common";
import { Label } from "components/bootstrap";
import useOwnerAction from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerAction";
import useCanEditSecurityEvent from "security-app/components/SecurityEvents/Alerts/hooks/useCanEditSecurityEvent";
const FlexLabel = styled(Label)`
  padding: 0 4px;
  width: fit-content;
`;
const RemoveButton = styled(IconButton)`
  height: auto;
  width: auto;
  padding: 0px;
  color: inherit;
  font-size: inherit;
`;
const OwnerLabel = ({ securityEvent }) => {
  const { onRemoveOwner, selectOwner, currentOwnerName } = useOwnerAction(securityEvent);
  const canEditOwner = useCanEditSecurityEvent(securityEvent.id);
  return currentOwnerName ? /* @__PURE__ */ React.createElement(FlexLabel, null, currentOwnerName, canEditOwner && /* @__PURE__ */ React.createElement(RemoveButton, { title: "Remove current owner", name: "close", onClick: onRemoveOwner })) : canEditOwner ? /* @__PURE__ */ React.createElement(IconButton, { name: "add", onClick: selectOwner, title: "Add owner" }) : /* @__PURE__ */ React.createElement("i", null, "No owner");
};
export default OwnerLabel;
